<template>
  <div id="emailBuilderContainer">
    <component
      v-bind:is="targetBuilder"
      :email-template-id="this.$route.params.id"
      :preview-mode="setPreviewMode(this.$route.query.previewMode)"
      header-title="Edit Email Template"
      v-on:load-failure="showLoadError"
      v-on:save="handleSave"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import BeeFreeBuilder from './BeeFreeBuilder'
import CustomBuilder from './CustomBuilder'
import UnknownBuilder from './UnknownBuilder'

export default {
  components: {
    [BeeFreeBuilder.name]: BeeFreeBuilder,
    [CustomBuilder.name]: CustomBuilder,
    [UnknownBuilder.name]: UnknownBuilder
  },
  computed: {
    targetBuilder () {
      const queryType = this.$route.query.type
      if (queryType === BeeFreeBuilder.templateType) {
        return BeeFreeBuilder.name
      } else if (queryType === CustomBuilder.templateType) {
        return CustomBuilder.name
      } else {
        return UnknownBuilder.name
      }
    }
  },
  methods: {
    ...mapMutations('EmailTemplateStore', ['saveEmailTemplate', 'resetEmailTemplate']),
    showLoadError (error) {
      this.resetEmailTemplate()
      this.$router.go(-1)
      this.$flash({
        showClose: true,
        message: 'An error occurred initializing the email editor. Try reloading page. ' + error.message,
        duration: 0,
        type: 'error'
      })
    },
    handleSave (emailBuilderData) {
      this.saveEmailTemplate(emailBuilderData)
      this.$router.go(-1)
      this.$flash({
        showClose: true,
        message: `Saved Email Template ${emailBuilderData.name}`,
        type: 'success',
        duration: 2500
      })
    },
    setPreviewMode (paramVal) {
      if (paramVal && paramVal.toString() === 'true') {
        return true
      } else {
        return false
      }
    }

  }
}
</script>
